import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OrganizationalUnitHelperService } from '../organizational-unit-helper.service';

@Pipe({
  name: 'orgUnitName',
  standalone: false,
})
export class OrgUnitNamePipe implements PipeTransform {
  private readonly organizationalUnitHelperService = inject(
    OrganizationalUnitHelperService,
  );

  transform(
    orgUnitId: string | undefined | null,
    emptyStringOnError = false,
  ): Observable<string | undefined> {
    if (orgUnitId) {
      return this.organizationalUnitHelperService.getOrgUnitNameById(
        orgUnitId,
        emptyStringOnError,
      );
    } else {
      return of(
        this.organizationalUnitHelperService.handleError(emptyStringOnError),
      );
    }
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [OrgUnitNamePipe],
  exports: [OrgUnitNamePipe],
})
export class OrgUnitNamePipeModule {}
